import { _CircleStarBase } from './circleStarBase'

export class _CircleStarDefault extends _CircleStarBase {
  cssType: 'default' | 'small' = 'default'
  protected initPC(): this {
    this['--favorited-icon-side'] = '0.34rem'
    return this
  }
  protected initH5(): this {
    this['--favorited-icon-side'] = '0.4rem'
    return this
  }
}
